import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { ApplicationListLayout, Content, PageNavigation } from 'core/layouts';
import { BaasicTable, TableFilter, EmptyState, QueryDropdown, BaasicButton, BasicQueryCheckbox } from 'core/components';

function NikoPatientListTemplate({ nikoPatientListViewStore }) {
    const {
        queryUtility,
        facilityStore,
        inactiveCheckboxStore,
        onInactiveChange,
        syncNikoPatient,
        tableLoading,
        tableStore,
        disabled
    } = nikoPatientListViewStore;
    return (
        <ApplicationListLayout store={nikoPatientListViewStore}>
            <PageNavigation>
                <BaasicButton
                    className="btn btn--base btn--primary u-mar--x--sml u-mar--y--sml"
                    label='Sync Niko Patient'
                    onClick={() => syncNikoPatient()}
                    disabled={disabled}
                    rotate icon={
                        disabled
                            ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                            : 'u-display--none'
                    }
                />
            </PageNavigation>
            <Content emptyRenderer={renderEmpty()} >
                <div className='u-mar--bottom--sml'>
                    <TableFilter queryUtility={queryUtility} filterVisible={true}>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-3 form__group">
                            <QueryDropdown queryUtility={queryUtility} store={facilityStore} propertyName="facilityId" label="Facility" />
                        </div>
                        <div className="col col-sml-12 col-med-6 col-xxlrg-2 checkbox--alignment form__group">
                            <label className="form__group__label"> </label>
                            <BasicQueryCheckbox
                                id='inactive'
                                queryUtility={queryUtility}
                                propertyName='inactive'
                                label='Include Inactive Patients?'
                                store={inactiveCheckboxStore}
                                onChange={onInactiveChange}
                            />
                        </div>
                    </TableFilter>
                </div>
                <div className="card--table">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                    />
                </div>
            </Content>

        </ApplicationListLayout>
    )
}

function renderEmpty() {
    return <EmptyState title='PATIENT.LIST.EMPTY_STATE.TITLE' description='PATIENT.LIST.EMPTY_STATE.DESCRIPTION' />
}

NikoPatientListTemplate.propTypes = {
    nikoPatientListViewStore: PropTypes.object
};

export default defaultTemplate(NikoPatientListTemplate);
